if (!customElements.get('rli-countdown-timer')) {
  class RliCountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;

      this.startTimeStr = this.dataset.startTime || null;
      this.endTimeStr = this.dataset.endTime || null;

      if (!this.endTimeStr) return;

      this.init();
    }

    init() {
      this.hoursPart1El = this.querySelector('.js-hours .countdown__number-part-1');
      this.hoursPart2El = this.querySelector('.js-hours .countdown__number-part-2');
      this.minsPart1El = this.querySelector('.js-mins .countdown__number-part-1');
      this.minsPart2El = this.querySelector('.js-mins .countdown__number-part-2');
      this.secsPart1El = this.querySelector('.js-secs .countdown__number-part-1');
      this.secsPart2El = this.querySelector('.js-secs .countdown__number-part-2');

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
      this.setAttribute('loaded', '');
    }

    parseTimeToday(timeStr) {
      var parts = timeStr.split(':').map(Number);
      var d = new Date();
      d.setHours(parts[0], parts[1], 0, 0);
      return d;
    }

    getRecurringTarget() {
      var now = new Date();
      var end = this.parseTimeToday(this.endTimeStr);
      var start = this.startTimeStr ? this.parseTimeToday(this.startTimeStr) : null;

      if (now < end) {
        return { target: end, active: !start || now >= start };
      }

      var tomorrow = new Date(end);
      tomorrow.setDate(tomorrow.getDate() + 1);
      return { target: tomorrow, active: false };
    }

    timer() {
      var result = this.getRecurringTarget();
      var wrapper = this.parentElement;

      if (!result.active) {
        this.style.display = 'none';
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      this.style.display = '';
      if (wrapper) wrapper.style.display = '';

      var timeDiff = Math.max(0, result.target - new Date());
      var hours = Math.floor(timeDiff / this.hour);
      var mins = Math.floor(timeDiff / this.minute);
      var secs = Math.floor(timeDiff / this.second);

      var displayHours = String(hours % 24).padStart(2, '0');
      var displayMins = String(mins - hours * 60).padStart(2, '0');
      var displaySecs = String(secs - mins * 60).padStart(2, '0');

      if (this.hoursPart1El) this.hoursPart1El.textContent = displayHours[0];
      if (this.hoursPart2El) this.hoursPart2El.textContent = displayHours[1];
      if (this.minsPart1El) this.minsPart1El.textContent = displayMins[0];
      if (this.minsPart2El) this.minsPart2El.textContent = displayMins[1];
      if (this.secsPart1El) this.secsPart1El.textContent = displaySecs[0];
      if (this.secsPart2El) this.secsPart2El.textContent = displaySecs[1];

      this.setAttribute('loaded', '');
    }
  }

  customElements.define('rli-countdown-timer', RliCountdownTimer);
}

document.querySelectorAll('.rli-announcement-bar').forEach(function (section) {
  var announcements = section.querySelectorAll('.rli-announcement');
  if (announcements.length <= 1) return;

  var current = 0;

  function show(index) {
    announcements.forEach(function (a) { a.classList.remove('is-active'); });
    announcements[index].classList.add('is-active');
    current = index;
  }

  var prev = section.querySelector('.rli-prev');
  var next = section.querySelector('.rli-next');

  if (prev) prev.addEventListener('click', function () {
    show((current - 1 + announcements.length) % announcements.length);
  });

  if (next) next.addEventListener('click', function () {
    show((current + 1) % announcements.length);
  });
});